// import { useNavigate } from "react-router-dom";
// import "../styles/ProductCard.css";

// export default function ProductCard({ product }) {
//   const navigate = useNavigate();

//   const OFFER_CID = 1781340284731;
//   const SPECIAL_CID = 1781353394225;

//   return (
//     <div
//       className="product-card"
//       onClick={() => navigate(`/product/${product.id}`)}
//       role="button"
//       tabIndex={0}
//     >
//       {/* BADGE SECTION */}
//       {Number(product.categoryId) === OFFER_CID && (
//         <span className="product-card__badge product-card__badge--offer">
//           🔥 OFFER
//         </span>
//       )}

//       {Number(product.categoryId) === SPECIAL_CID && (
//         <span className="product-card__badge product-card__badge--special">
//           ⭐ SPECIAL
//         </span>
//       )}

//       {/* IMAGE SECTION */}
//       <div className="product-card__image-wrapper">
//         <img
//           src={product.image || ""}
//           alt={product.name || "product"}
//           className="product-card__image"
//         />
//       </div>

//       {/* CONTENT SECTION */}
//       <div className="product-card__content">
//         <h3 className="product-card__title">{product.name}</h3>

//         {/* <p className="product-card__description">
//           {product.desc?.slice(0, 60) || "No description available"}...
//         </p> */}

//         <p className="product-card__description">
//           {(product.desc || "")
//             .replace(/<[^>]*>/g, "") // Remove HTML tags
//             .replace(/&nbsp;/g, " ") // Remove &nbsp;
//             .substring(0, 60)}
//           ...
//         </p>

//         {/* <p className="product-card__price">₹{product.price}</p> */}
//         <div className="product-card__price-wrapper">

//           {Number(product.categoryId) === OFFER_CID &&
//             product.originalPrice && (
//               <span className="product-card__original-price">
//                 ₹{product.originalPrice}
//               </span>
//             )}

//           <span className="product-card__price">
//             ₹{product.price}
//           </span>

//         </div>
//         {Number(product.categoryId) === OFFER_CID &&
//           product.originalPrice && (
//             <span className="product-card__discount">
//               {Math.round(
//                 ((product.originalPrice - product.price) /
//                   product.originalPrice) *
//                 100
//               )}
//               % OFF
//             </span>
//           )}
//       </div>
//     </div>
//   );
// }


import { useNavigate } from "react-router-dom";
import "../styles/ProductCard.css";

export default function ProductCard({ product }) {
  const navigate = useNavigate();

  const OFFER_CID = 1781340284731;
  const SPECIAL_CID = 1781353394225;

  return (
    <div
      className="product-card"
      onClick={() => navigate(`/product/${product.id}`)}
      role="button"
      tabIndex={0}
    >
      {/* BADGE SECTION */}
      {Number(product.categoryId) === OFFER_CID && (
        <span className="product-card__badge product-card__badge--offer">
          🔥 OFFER
        </span>
      )}

      {Number(product.categoryId) === SPECIAL_CID && (
        <span className="product-card__badge product-card__badge--special">
          ⭐ SPECIAL
        </span>
      )}

      {/* IMAGE SECTION */}
      <div className="product-card__image-wrapper">
        <img
          src={product.image || ""}
          alt={product.name || "product"}
          className="product-card__image"
        />
      </div>

      {/* CONTENT SECTION */}
      <div className="product-card__content">
        <h3 className="product-card__title">{product.name}</h3>

        <p className="product-card__description">
          {(product.desc || "")
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, " ")
            .substring(0, 60)}
          ...
        </p>

        {/* ✅ PRICE — works for ALL products now */}
        <div className="product-card__price-wrapper">
          {product.originalPrice && (
            <span className="product-card__original-price">
              ₹{product.originalPrice}
            </span>
          )}
          <span className="product-card__price">₹{product.price}</span>
        </div>

        {/* ✅ DISCOUNT BADGE — shows for ANY product with originalPrice */}
        {product.originalPrice && (
          <span className="product-card__discount">
            {Math.round(
              ((product.originalPrice - product.price) / product.originalPrice) * 100
            )}% OFF
          </span>
        )}
      </div>
    </div>
  );
}